<template>
	<div>
		<v-row v-if="type=='single'" @click="clickNews">
            <v-col cols="6">
				<v-skeleton-loader type="heading" v-if="loading"></v-skeleton-loader>
                <span v-else class="primary--text newstitle">{{item.title}}</span>
                <br>
				<v-skeleton-loader type="heading" v-if="loading" class="timestamp-text"></v-skeleton-loader>
                <span v-else class="timestamp-text">{{formatTimestamp(item.timestamp)}}</span>
            </v-col>
            <v-col cols="6">
                <v-img :src="item == null ? '' : formatImage(item.imageUrl)" :aspect-ratio="16/9">
					<template v-slot:placeholder>
						<v-skeleton-loader type="image"></v-skeleton-loader>
      				</template>
				</v-img>
            </v-col>
		</v-row>
        <v-card v-else-if="item.hasOwnProperty('videoFrame')" class="news-item-default news-item-video" tile elevation="0">
            <div class="iframe-holder">
                <span v-html="item.videoFrame"></span>
            </div>
			<v-list-item two-line class="px-6" @click="clickNews">
				<v-list-item-content>
					<v-list-item-title class="headline mb-1 primary--text">{{item.title}}</v-list-item-title>
                    <span v-html="item.message"></span>
				</v-list-item-content>
			</v-list-item>
            <v-divider class="mx-6"></v-divider>
		</v-card>
		<HeadlineItem @click="clickNews" v-else-if="type=='big'" :title="item.title" :src="formatImage(item.imageUrl)" :message="item.message" divider></HeadlineItem>
		<v-card v-else class="news-item-default" tile elevation="0" @click="clickNews">
			<v-list-item two-line class="px-6">
				<v-list-item-content>
					<v-list-item-title class="headline mb-1 primary--text">{{item.title}}</v-list-item-title>
                    <span v-html="item.message"></span>
				</v-list-item-content>
				<v-list-item-avatar tile size="80" color="grey" v-if="item.imageUrl">
                    <v-img :src="item.imageUrl"></v-img>
                </v-list-item-avatar>
			</v-list-item>
            <v-divider class="mx-6"></v-divider>
		</v-card>
	</div>
</template>
<script>
import HeadlineItem from '@/components/design/HeadlineItem';

export default {
	data() {
		return {};
	},
	methods: {
		formatImage(url) {
			if (typeof url === "undefined") {
				return require("@/assets/news-default.svg");
			}
			if (url == "/news-default.svg") {
				return require("@/assets/news-default.svg");
			}
			return url;
		},
		clickNews() {
			if(this.item == null) {
				return;
			}
			this.$emit("click", this.item);
		},
		formatTimestamp(timestamp) {
			if (timestamp == null) {
				return "-/-";
			}
			var timestampDate = new Date(timestamp.seconds * 1000);
			return (
				timestampDate
					.getDate()
					.toString()
					.padStart(2, "0") +
				"." +
				(timestampDate.getMonth() + 1).toString().padStart(2, "0") +
				"." +
				timestampDate.getFullYear()
			);
		}
	},
	props: {
        item: Object,
        type: {
            type: String,
            default: "default"
		},
		loading: Boolean
	},
	components: {
		HeadlineItem
	}
};
</script>
<style lang="scss">
.col {
	position: relative;
}
.newstitle {
	min-height: 2.7em;
	max-height: 5.7em;
	display: -webkit-box;
   	-webkit-box-orient: vertical;
   	-webkit-line-clamp: 4;
	overflow: hidden;
	text-overflow: ellipsis;
}
.timestamp-text {
	width: 100%;
	font-size: 0.9em;
	position: absolute;
	bottom: 12px;
}
.news-item-big {
    .headline {
        font-size: 1em!important;
    }
    span {
        font-size: 1em;
    }
}
.news-item-default {
    .headline {
        font-size: 1em!important;
    }
    .v-avatar {
        border-radius: 10px;
    }
    span {
        font-size: 0.9em;
    }
	&.news-item-video {
        background-color: rgb(240, 240, 240);
    }
}
.iframe-holder {
    position:relative;
    padding-top:56.25%;
}
iframe {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
}
</style>